<template>
    <div id='app'>
        <Home />
    </div>
</template>

<script>
var Home =  require('./views/Home');

module.exports = {
    name: 'app',
    components: {
        Home
    },
    data(){
        return{

        }
    },
    created () {
        
    },
    mounted () {
        
    },
    methods: {
        
    },
    computed: {
        
    }

}
</script>

<style scoped>
#app{
    height: 100%;
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: center;
}
</style>